import { render, staticRenderFns } from "./DetalhesGrupo.vue?vue&type=template&id=37fc81dd&scoped=true&"
import script from "./DetalhesGrupo.vue?vue&type=script&lang=js&"
export * from "./DetalhesGrupo.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesGrupo.vue?vue&type=style&index=0&id=37fc81dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc81dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VDataTable,VDivider,VIcon,VMain,VRow})
